// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../css-loader/index.js?{\"sourceMap\":true}!../../../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6397fd74\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../sass-loader/lib/loader.js?{\"sourceMap\":true}!../../../../../../vue-loader/lib/selector.js?type=styles&index=0!./PageLPBillingsDetail.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../../vue-style-loader/lib/addStylesClient.js")("9c2b32ce", content, true);


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6397fd74","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/detail/PageLPBillingsDetail.vue
// module id = l18U
// module chunks = 72